// @flow

import type {
	IGALog,
	PageViewGALogParams,
	EventGALogParams,
} from '..';


export class PageViewGALog
	implements IGALog {

	title: ?string;
	page: ?string;
	location: ?string;

	constructor (params: PageViewGALogParams) {
		this.hitType = 'pageview';
		this.title = params.title;
		this.page = params.page;
		this.location = params.location;
	}
}

export class EventGALog
	implements IGALog {
	
	eventCategory: string;
	eventAction: string;
	eventLabel: ?string;
	eventValue: ?number;

	constructor (params: EventGALogParams) {
		this.hitType = 'event';
		this.eventCategory = params.eventCategory;
		this.eventAction = params.eventAction;
		this.eventLabel = params.eventLabel;
		this.eventValue = params.eventValue;
	}
}